// Global Modal theme configuration
// This theme will be applied to all Modal components across the app

export const antDesignTheme = {
  components: {

    Form: {
      labelColor: '#fff',
    },

    Dropdown: {
      colorBgElevated:'rgba(75, 75, 75, 0.9)',
      colorText: '#fff',
      colorBorder: 'rgba(255, 255, 255, 0.1)',
    },
    Button: {
      defaultBg: 'rgba(255, 255, 255, 0.075)',
      controlHeight: 36,
      borderRadius: 4,
      defaultBorderColor: 'rgba(255, 255, 255, 0.075)',
      defaultHoverBg: 'rgba(226, 215, 215, 0.2)',
      defaultHoverBorderColor: 'rgba(226, 215, 215, 0.2)',
      defaultActiveBg: 'rgba(255, 255, 255, 0.01)',
      defaultActiveBorderColor: 'rgba(255, 255, 255, 0.075)',
      defaultActiveColor: 'rgba(255, 255, 255, 0.5)',
      colorText: '#fff',
      defaultHoverColor: '#fff',
      fontWeight: 600,

      /* here is your component tokens */
    },
    Modal: {
      titleFontSize: 20,
      contentBg: 'rgba(75, 75, 75, 0.9)',
      headerBg: 'transparent',
      titleColor: '#fff',
      colorText: '#fff',
      borderColor: 'rgba(255, 255, 255, 0.1)',
    },
    Input: {
      colorBgContainer: 'rgba(255, 255, 255, 0.075)',
      colorBorder: 'rgba(255, 255, 255, 0.075)',
      colorText: '#fff',
      colorTextPlaceholder: '#bbb',
      borderRadius: 4,
      controlHeight: 36,
      fontFamily: 'outfit',
    },
    InputNumber: {
      colorBgContainer: 'rgba(255, 255, 255, 0.075)',
      colorBorder: 'rgba(255, 255, 255, 0.075)',
      colorText: '#fff',
      colorTextPlaceholder: '#bbb',
      borderRadius: 4,
      controlHeight: 36,
      fontFamily: 'outfit',
    },
    Segmented: {
      trackBg: 'rgba(255, 255, 255, 0.075)',
      itemColor: '#ccc',
      itemSelectedColor: '#fff',
      itemHoverColor: '#fff',
      borderRadiusSM: 4,
      itemSelectedBg: 'rgba(255, 255, 255, 0.075)',
    },
    Card: {
      colorBgContainer: 'transparent',
      colorBorderSecondary: 'rgba(255, 255, 255, 0.1)',
    },
    DatePicker: {
      // activeBg: 'rgba(255, 255, 255, 0.075)',
      // colorBgContainer: 'rgba(255, 255, 255, 0.075)',
      // colorBorder: 'rgba(255, 255, 255, 0.075)',
      // colorText: '#fff',
     
      colorBgContainer: 'rgba(255, 255, 255, 0.075)',
      activeBg: 'rgba(255, 255, 255, 0.075)',
      colorBorder: 'rgba(255, 255, 255, 0.075)',

   
      controlItemBgActive: 'rgba(255, 255, 255, 0.1)',

      colorTextPlaceholder: '#bbb',
      borderRadius: 4,
      controlHeight: 36,
      colorBgElevated: 'rgba(75, 75, 75, 0.95)',
      colorText: '#fff',
      colorTextHeading: '#fff',
      colorIcon: '#bbb',
      colorIconHover: '#fff',
      colorTextDisabled: '#aaa',
      cellActiveWithRangeBg: 'rgba(255, 255, 255, 0.1)',
      fontFamily: 'outfit',
      
    },
    TimePicker: {
      colorBgElevated: 'rgba(75, 75, 75, 0.95)',
      colorText: '#fff',
      colorTextHeading: '#fff',
 

    },
    Slider: {
      railBg: 'rgba(255, 255, 255, 0.075)',
      trackBg: 'rgba(255, 255, 255, 0.2)',
      handleColor: 'rgba(255, 255, 255, 0.8)',
      handleActiveColor: '#fff',
      dotBorderColor: 'rgba(255, 255, 255, 0.3)',
      dotActiveBorderColor: 'rgba(255, 255, 255, 0.6)',
    },
    Segmented: {
      trackBg: 'rgba(255, 255, 255, 0.075)',
      itemColor: '#ccc',
      itemSelectedColor: '#fff',
      itemHoverColor: '#fff',
      borderRadiusSM: 4,
      itemSelectedBg: 'rgba(255, 255, 255, 0.075)',
    },
    Form: {
      itemMarginBottom: 16,
      labelColor: '#fff',
    }
  }
}; 